import React, { PureComponent } from 'react';
import { Button, Checkbox } from 'antd';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { GlobalState } from '../store/reducers';
import { Actions } from '../store/actions';
import { setLabVitals, updatePrintConfig } from '../store/actions/prescriptionPad';
import { LabVitalEntity, PatientPersonalProfile } from '../store/types/prescription';
import {
    getLabVitals,
    getPatientPersonalProfile,
    getPrintConfigs,
} from '../store/selectors/prescriptionPad';
import { Data } from '../store/types/LabTests';
import { AnimatePresence } from 'framer-motion';
import { PrintConfig, PrintConfigItemV2 } from '../api/pushVisit';
import { structureLabVital } from './LabTestsTable';
import LabTestsRightPadV2RightPopUp from './LabTestsRightPadV2RightPopUp';

type State = {
    isModalOpen: boolean;
};

type Props = {
    data: Data[];
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    patient?: PatientPersonalProfile;
    labVitals?: LabVitalEntity[];
    printConfig: PrintConfig | undefined;
};

class LabTestsPadV2 extends PureComponent<Props, State> {
    state: State = {
        isModalOpen: false,
    };

    openModal = () => {
        this.setState({ isModalOpen: true });
    };

    closeModal = () => {
        this.setState({ isModalOpen: false });
    };

    setLabVital = (labVitals: LabVitalEntity[]) => {
        const { dispatch } = this.props;
        const allVitals = labVitals.map((labVital) => structureLabVital(labVital));
        dispatch(setLabVitals(allVitals));
    };

    onClickOutOfRange = (isOutOfRange: boolean) => {
        const { dispatch, printConfig } = this.props;

        if (printConfig) {
            dispatch(
                updatePrintConfig({
                    ...printConfig,
                    labVitals: {
                        ...((printConfig?.labVitals as PrintConfigItemV2) || {}),
                        isOutOfRange: isOutOfRange,
                    },
                }),
            );
        }
    };

    render(): React.ReactNode {
        const { data, patient, labVitals, printConfig } = this.props;
        const { isModalOpen } = this.state;
        return (
            <div className="flex items-center space-x-8 mr-8">
                <Checkbox
                    onChange={(e) => {
                        this.onClickOutOfRange(e.target.checked);
                    }}
                    checked={(printConfig?.labVitals as PrintConfigItemV2)?.isOutOfRange as boolean}
                    className="font-700"
                >
                    Print only Out of range in Rx
                </Checkbox>

                <Button
                    onClick={this.openModal}
                    className="flex items-center px-16 py-5 btn--small space-x-8 secondary-btn"
                    style={{
                        fontWeight: 400,
                    }}
                    id="all-lab-tests-bt"
                >
                    <p className="text-14">Browse Panels</p>
                    <div className="flex items-center justify-center w-16 h-16">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            className="w-15 h-15"
                        >
                            <path
                                d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"
                                fill="#004BA8"
                            />
                        </svg>
                    </div>
                </Button>
                <AnimatePresence>
                    {isModalOpen && (
                        <LabTestsRightPadV2RightPopUp
                            data={data}
                            patient={patient}
                            labVitals={labVitals}
                            closeModal={this.closeModal}
                            setLabVital={this.setLabVital}
                        />
                    )}
                </AnimatePresence>
            </div>
        );
    }
}

export default connect((state: GlobalState) => ({
    patient: getPatientPersonalProfile(state),
    labVitals: getLabVitals(state),
    printConfig: getPrintConfigs(state),
}))(LabTestsPadV2);
